document.addEventListener('click', function (event) {
  const thumb = event.target.closest('[data-gallery-thumb]');
  if (thumb) {
    const gallery = thumb.closest('[data-gallery]');
    const targetId = thumb.dataset.galleryThumb;
    gallery.querySelectorAll('[data-media-id]').forEach((frame) => {
      const active = frame.dataset.mediaId === targetId;
      frame.hidden = !active;
      if (!active) frame.querySelectorAll('video').forEach((video) => video.pause());
    });
    const expand = gallery.querySelector('[data-gallery-expand]');
    if (expand) expand.hidden = !gallery.querySelector('[data-media-id]:not([hidden]) > img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.galleryThumb === targetId));
    });
  }

});

document.addEventListener('change', function (event) {
  const option = event.target.closest('[data-option-select]');
  if (option) {
    const pickers = option.closest('[data-option-pickers]');
    const selectedIds = Array.from(pickers.querySelectorAll('[data-option-select]')).map((select) => select.value);
    const selectedValue = option.selectedOptions[0];
    const destination = selectedValue.dataset.productUrl || window.location.pathname;
    const url = new URL(destination, window.location.origin);
    if (url.pathname === window.location.pathname) {
      url.searchParams.delete('variant');
      url.searchParams.set('option_values', selectedIds.join(','));
    }
    const update = new CustomEvent('shopping:variant', { cancelable: true, detail: { url: url.toString(), optionId: option.id } });
    if (document.dispatchEvent(update)) window.location.assign(url.toString());
  }

  const sort = event.target.closest('[data-sort-select]');
  if (sort && sort.form) sort.form.requestSubmit();
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.commerce-filter-panel.is-open').forEach((panel) => {
    if (panel.closest('[data-filter-dialog]')) return;
    panel.classList.remove('is-open');
    const toggle = document.querySelector('[aria-controls="' + panel.id + '"]');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
  });
});

/* Saved gifts are a device-local shortlist; products and prices are always loaded fresh from Shopify. */
(() => {
  const storageKey = 'myraa:wishlist:v1';
  const productCache = new Map();
  const page = document.querySelector('[data-wishlist-page]');
  const rootUrl = page?.dataset.rootUrl || window.Shopify?.routes?.root || '/';
  let memoryHandles = [];
  let renderVersion = 0;

  function validHandle(handle) {
    return typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle);
  }

  function readHandles() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(stored)) return [];
      memoryHandles = Array.from(new Set(stored.filter(validHandle)));
    } catch (_) {
      /* Browsers can disable storage; the shortlist still works until the tab closes. */
    }
    return [...memoryHandles];
  }

  function writeHandles(handles, rerender = true) {
    memoryHandles = Array.from(new Set(handles.filter(validHandle)));
    try { window.localStorage.setItem(storageKey, JSON.stringify(memoryHandles)); } catch (_) { /* in-memory fallback */ }
    refreshControls();
    if (rerender) renderWishlist();
  }

  function refreshControls() {
    const saved = new Set(readHandles());
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = saved.has(button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? button.dataset.removeLabel : button.dataset.saveLabel);
      button.title = active ? button.dataset.removeLabel : button.dataset.saveLabel;
      const text = button.querySelector('[data-wishlist-text]');
      if (text) text.textContent = active ? button.dataset.savedText : button.dataset.saveText;
    });
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
      count.textContent = saved.size;
      count.hidden = saved.size === 0;
    });
  }

  function money(cents) {
    const currency = page?.dataset.currency || 'INR';
    const amount = Number(cents) / 100;
    const fractionDigits = Number(cents) % 100 === 0 ? 0 : 2;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency', currency, minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits
      }).format(amount);
    } catch (_) {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }).format(amount);
    }
  }

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function productUrl(handle) {
    const base = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';
    return base + 'products/' + encodeURIComponent(handle);
  }

  function sizedImage(source, width) {
    const url = new URL(source, window.location.origin);
    url.searchParams.set('width', String(width));
    url.searchParams.set('height', String(width));
    url.searchParams.set('crop', 'center');
    url.searchParams.delete('pad_color');
    return url.toString();
  }

  function cardForProduct(product) {
    const title = product.title || product.handle;
    const handle = product.handle;
    const url = productUrl(handle);
    const article = element('article', 'pcard');
    const media = element('div', 'pc-media myraa-square-media');
    const imageLink = element('a', 'pc-img');
    imageLink.href = url;
    imageLink.setAttribute('aria-label', title);
    const rawImage = product.featured_image || product.images?.[0];
    const imageSource = typeof rawImage === 'string' ? rawImage : rawImage?.src || rawImage?.url;
    if (imageSource) {
      const image = element('img', 'pc-image-primary');
      image.src = sizedImage(imageSource, 1500);
      image.srcset = [320, 480, 640, 900, 1200, 1500].map(width => sizedImage(imageSource, width) + ' ' + width + 'w').join(', ');
      image.sizes = '(max-width: 600px) 50vw, (max-width: 1000px) 33vw, 25vw';
      image.width = 1500;
      image.height = 1500;
      image.alt = title;
      image.loading = 'lazy';
      imageLink.append(image);
      const rawSecond = product.images?.[1];
      const secondSource = typeof rawSecond === 'string' ? rawSecond : rawSecond?.src || rawSecond?.url;
      if (secondSource) {
        const second = element('img', 'pc-image-secondary');
        second.src = sizedImage(secondSource, 1500);
        second.srcset = [320, 480, 640, 900, 1200, 1500].map(width => sizedImage(secondSource, width) + ' ' + width + 'w').join(', ');
        second.sizes = image.sizes;
        second.width = 1500;
        second.height = 1500;
        second.alt = '';
        second.loading = 'lazy';
        imageLink.append(second);
      }
    } else {
      imageLink.append(element('span', 'pc-no-image', page.dataset.imageUnavailable));
    }
    media.append(imageLink);

    const tags = Array.isArray(product.tags) ? product.tags : typeof product.tags === 'string' ? product.tags.split(',') : [];
    const badge = tags.find((tag) => ['exclusive', 'limited edition', 'new arrival', 'bestseller'].includes(String(tag).trim().toLowerCase()));
    if (badge) {
      const ribbon = element('span', 'pc-ribbon');
      ribbon.append(element('span', 'pc-ribbon-label', String(badge).trim()));
      media.append(ribbon);
    }

    const body = element('div', 'pc-body');
    const heading = element('h3', 'pc-title');
    const titleLink = element('a', '', title.charAt(0).toUpperCase() + title.slice(1).toLowerCase());
    titleLink.title = title;
    titleLink.href = url;
    heading.append(titleLink);
    body.append(heading);
    const bottom = element('div', 'pc-bottom');
    const price = element('div', 'pc-price');
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const available = product.available ?? variants.some((variant) => variant.available);
    let priceText = available ? money(product.price) : page.dataset.soldOut;
    if (available && product.price_varies) priceText = page.dataset.from + ' ' + priceText;
    price.append(element('strong', '', priceText));
    const firstVariant = variants[0];
    if (available && !product.price_varies && firstVariant && Number(firstVariant.compare_at_price) > Number(firstVariant.price)) {
      price.append(element('s', '', money(firstVariant.compare_at_price)));
      const discount = Math.round((Number(firstVariant.compare_at_price) - Number(firstVariant.price)) * 100 / Number(firstVariant.compare_at_price));
      price.append(element('span', 'pc-discount', discount + '% OFF'));
    }
    bottom.append(price);

    const save = element('button', 'pc-wishlist');
    save.type = 'button';
    save.dataset.wishlistToggle = '';
    save.dataset.productHandle = handle;
    save.dataset.saveLabel = page.dataset.saveTemplate.replace('__TITLE__', title);
    save.dataset.removeLabel = page.dataset.removeTemplate.replace('__TITLE__', title);
    save.setAttribute('aria-pressed', 'true');
    save.setAttribute('aria-label', save.dataset.removeLabel);
    save.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.5 8.5c0 4.5-8.5 10-8.5 10s-8.5-5.5-8.5-10a4.5 4.5 0 0 1 8.5-2 4.5 4.5 0 0 1 8.5 2Z"/></svg>';
    media.append(save);
    article.append(media);

    if (available && variants.length === 1 && variants[0].available) {
      const form = element('form', 'pcard-form');
      form.action = page.dataset.cartAddUrl;
      form.method = 'post';
      const id = element('input');
      id.type = 'hidden';
      id.name = 'id';
      id.value = variants[0].id;
      const add = element('button', 'pc-add');
      add.type = 'submit';
      add.setAttribute('aria-label', page.dataset.addTemplate.replace('__TITLE__', title));
      add.textContent = page.dataset.addText;
      form.append(id, add);
      bottom.append(form);
    } else {
      const detailsLink = element('a', 'pc-add');
      detailsLink.href = url;
      detailsLink.setAttribute('aria-label', page.dataset.viewTemplate.replace('__TITLE__', title));
      detailsLink.textContent = page.dataset.viewText;
      bottom.append(detailsLink);
    }
    body.append(bottom);
    article.append(body);
    return article;
  }

  async function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    const request = (async () => {
      const response = await fetch(productUrl(handle) + '.js', { credentials: 'same-origin' });
      if (response.status === 404) return null;
      if (!response.ok) throw new Error(`Product request ${response.status}`);
      return response.json();
    })();
    productCache.set(handle, request);
    try { return await request; }
    catch (error) { productCache.delete(handle); throw error; }
  }

  async function renderWishlist() {
    if (!page) return;
    const version = ++renderVersion;
    const grid = page.querySelector('[data-wishlist-grid]');
    const empty = page.querySelector('[data-wishlist-empty]');
    const status = page.querySelector('[data-wishlist-status]');
    const handles = readHandles();
    Array.from(grid.children).forEach(card => {
      if (!handles.includes(card.dataset.wishlistHandle)) card.remove();
    });
    empty.hidden = true;
    if (!handles.length) {
      status.textContent = '';
      empty.hidden = false;
      return;
    }
    status.textContent = page.dataset.loadingText;
    const missing = [];
    let hadError = false;
    let nextIndex = 0;
    async function worker() {
      while (nextIndex < handles.length && version === renderVersion) {
        const handle = handles[nextIndex++];
        if (Array.from(grid.children).some(card => card.dataset.wishlistHandle === handle)) continue;
        try {
          const product = await fetchProduct(handle);
          if (version !== renderVersion) return;
          if (!product) { missing.push(handle); continue; }
          const card = cardForProduct(product);
          card.dataset.wishlistHandle = handle;
          const position = handles.indexOf(handle);
          const following = Array.from(grid.children).find(node => handles.indexOf(node.dataset.wishlistHandle) > position);
          grid.insertBefore(card, following || null);
          refreshControls();
        } catch (_) { hadError = true; }
      }
    }
    await Promise.all(Array.from({ length: Math.min(8, handles.length) }, worker));
    if (version !== renderVersion) return;
    if (missing.length) writeHandles(handles.filter((handle) => !missing.includes(handle)), false);
    refreshControls();
    status.textContent = hadError ? page.dataset.errorText : grid.children.length === 1 ? page.dataset.loadedOne : page.dataset.loadedOther.replace('__COUNT__', String(grid.children.length));
    if (!grid.children.length && !hadError) empty.hidden = false;
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    const handle = button.dataset.productHandle;
    if (!validHandle(handle)) return;
    const handles = readHandles();
    writeHandles(handles.includes(handle) ? handles.filter((entry) => entry !== handle) : [...handles, handle]);
  });
  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) { refreshControls(); renderWishlist(); }
  });
  document.addEventListener('shopify:section:load', () => { refreshControls(); renderWishlist(); });
  document.addEventListener('shopping:section:updated', refreshControls);
  refreshControls();
  renderWishlist();
})();
document.addEventListener('click', function (event) {
  const budget = event.target.closest('[data-price-min]');
  if (!budget) return;
  const facet = budget.closest('.commerce-facet');
  const inputs = facet.querySelectorAll('.commerce-price-range input');
  if (inputs.length !== 2) return;
  inputs[0].value = budget.dataset.priceMin;
  inputs[1].value = budget.dataset.priceMax;
  inputs.forEach(input => input.removeAttribute('max'));
  budget.closest('form').requestSubmit();
});

/* Prepare a delivery enquiry; do not invent a live serviceability result. */
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-delivery-prepare]');
  if (!button) return;
  const panel = button.closest('[data-delivery-enquiry]');
  const input = panel.querySelector('input');
  const status = panel.querySelector('[data-delivery-status]');
  const link = panel.querySelector('[data-delivery-link]');
  const pin = input.value.trim();
  status.hidden = false;
  if (!/^[1-9][0-9]{5}$/.test(pin)) {
    input.setAttribute('aria-invalid', 'true');
    status.textContent = 'Please enter a valid 6-digit Indian PIN code.';
    link.hidden = true;
    input.focus();
    return;
  }
  input.removeAttribute('aria-invalid');
  status.textContent = 'Ask our team to confirm delivery to ' + pin + ' and your preferred date.';
  link.href = 'https://wa.me/919811443737?text=' + encodeURIComponent('Hello Myraa, please confirm delivery availability and timing for ' + panel.dataset.productTitle + ' to PIN code ' + pin + '. My preferred delivery date is: ');
  link.hidden = false;
});
document.addEventListener('input', function(event) {
  const panel = event.target.closest('[data-delivery-enquiry]');
  if (!panel) return;
  panel.querySelector('[data-delivery-link]').hidden = true;
  panel.querySelector('[data-delivery-status]').hidden = true;
  event.target.removeAttribute('aria-invalid');
});

document.addEventListener('click', function(event) {
 const trigger = event.target.closest('[data-gallery-expand]');
 if (trigger) {
   const gallery = trigger.closest('[data-gallery]');
   const source = gallery.querySelector('[data-media-id]:not([hidden]) > img');
   const dialog = gallery.querySelector('[data-image-dialog]');
   if (!source || !dialog) return;
   const image = dialog.querySelector('[data-expanded-image]');
   image.src = source.src;
   image.alt = source.alt;
   dialog.showModal();
 }
 const close = event.target.closest('[data-image-close]');
 if (close) close.closest('dialog').close();
});
